import * as Styled from './Layout.styled';
import { LayoutProps } from './Layout.types';
import Space from '../Space/Space';

export const Layout = ({ header, footer, children }: LayoutProps) => {
  return (
    <Styled.Layout>
      {header && (
        <>
          {header}
          <Space space="M24" />
        </>
      )}
      {children && children}
      {footer && (
        <>
          <Space space="M24" />
          {footer}
        </>
      )}
    </Styled.Layout>
  );
};

export default Layout;
